import { getAPI } from './api';

export const handleCheckReCapture = sessionID => {
	//session_check_recapture/<session_key>
	return getAPI(`session_check_recapture/${sessionID}`);
};
export const handleCheckNative = sessionID => {
	//session_check_recapture/<session_key>
	return getAPI(`native_photos/session/${sessionID}`);
};
